import type { Route } from './components/AppShell'
import type { Clip } from './types'

export type ActivityLocation = { route: Route; projectId: string | null; clipId: string | null; sourceId: string | null }

export function activityClipLocation(clip: Clip): ActivityLocation {
  const route = ['approved', 'editing', 'changes_requested'].includes(clip.status) ? 'editor'
    : ['final_review', 'complete'].includes(clip.status) ? 'final' : 'review'
  return { route, clipId: clip.id, sourceId: null, projectId: null }
}
